export function getSender() {
  return 'cast' in window ? window.cast.framework : undefined;
}

export function getContext() {
  const sender = getSender();
  return sender?.CastContext.getInstance();
}

export function getPlayer() {
  return 'cast' in window ? new window.cast.framework.RemotePlayer() : undefined;
}

export function getChrome() {
  if ('chrome' in window) {
    return window.chrome;
  }

  return undefined;
}

export function getChromeCast() {
  const chrome = getChrome();

  if (!chrome) {
    return undefined;
  }

  return 'cast' in chrome ? window.chrome.cast : undefined;
}
